import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const AppRoute = ({ children, allowedRoles = [] }) => {
    const location = useLocation();
    
    // Get user from localStorage (fallback to an empty object if null)
    const user = JSON.parse(localStorage.getItem("user") || "{}");

    // console.log("User is checked in AppRoute:", user);

    // Redirect to login if user is not authenticated
    if (!user?.type) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Ensure roles exist and are an array
    const userRoles = Array.isArray(user.type) ? user.type : user.type.split(",");

    // Check if user has at least one of the required roles
    const hasPermission = allowedRoles.length === 0 || allowedRoles.some(role => userRoles.includes(role));

    // Redirect to unauthorized page if user doesn't have permission
    if (!hasPermission) {
        return <Navigate to="/unauthorized" replace />;
    }

    return <>{children}</>;
};

export default AppRoute;